/**
 * App WebView ↔ H5 Bridge
 *
 * App 侧注入：
 * - URL ?token=xxx（优先）
 * - window.GoTrustBridge / Flutter JavaScriptChannel `GoTrustBridge`
 */
function queryToken() {
  try {
    const q = new URLSearchParams(window.location.search || '')
    const fromQuery = q.get('token')
    if (fromQuery) return fromQuery
    const hash = window.location.hash || ''
    const i = hash.indexOf('?')
    if (i >= 0) {
      return new URLSearchParams(hash.slice(i + 1)).get('token')
    }
  } catch (_) {
    // ignore malformed URL
  }
  return null
}

export function getToken() {
  const fromUrl = queryToken()
  if (fromUrl) return fromUrl
  if (window.__GOTRUST_TOKEN__) return window.__GOTRUST_TOKEN__
  return null
}

export function setToken(token) {
  if (token) window.__GOTRUST_TOKEN__ = token
}

function postToApp(action, payload = {}) {
  const message = JSON.stringify({ action, ...payload })
  try {
    if (window.GoTrustBridge && typeof window.GoTrustBridge.postMessage === 'function') {
      window.GoTrustBridge.postMessage(message)
      return true
    }
  } catch (_) {
    // ignore missing Android/Flutter bridge
  }
  try {
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.GoTrustBridge
    ) {
      window.webkit.messageHandlers.GoTrustBridge.postMessage(message)
      return true
    }
  } catch (_) {
    // ignore missing iOS WKWebView bridge
  }
  return false
}

/** 通知 App 需要登录；返回是否成功发给 App */
export function requireLogin() {
  return postToApp('requireLogin')
}

export function closeWebView() {
  return postToApp('close')
}

export function openCouponList() {
  return postToApp('openCouponList')
}

export function isInApp() {
  return !!(
    (window.GoTrustBridge && window.GoTrustBridge.postMessage) ||
    (window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.GoTrustBridge)
  )
}
